import './sectionHead.css'
const SectionHead = ({ icon, title }) => {
  return (
<div className="section-head">
  <span className="section-head__icon">{icon}</span>
  <h2>{title}</h2>
</div>
  )
}

export default SectionHead
